import React, { useState } from "react";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

const ItalicTextGenerator = () => {
  const [textareaValue, setTextareaValue] = useState("");
  const [convertedText, setConvertedText] = useState("");

  const handleChange = (event) => {
    const text = event.target.value;
    setTextareaValue(text);
    setConvertedText(convertToItalic(text));
  };

  const convertToItalic = (text) => {
    const italicMap = {
      a: "𝘢", b: "𝘣", c: "𝘤", d: "𝘥", e: "𝘦", f: "𝘧", g: "𝘨",
      h: "𝘩", i: "𝘪", j: "𝘫", k: "𝘬", l: "𝘭", m: "𝘮", n: "𝘯",
      o: "𝘰", p: "𝘱", q: "𝘲", r: "𝘳", s: "𝘴", t: "𝘵", u: "𝘶",
      v: "𝘷", w: "𝘸", x: "𝘹", y: "𝘺", z: "𝘻",
      A: "𝘈", B: "𝘉", C: "𝘊", D: "𝘋", E: "𝘌", F: "𝘍", G: "𝘎",
      H: "𝘏", I: "𝘐", J: "𝘑", K: "𝘒", L: "𝘓", M: "𝘔", N: "𝘕",
      O: "𝘖", P: "𝘗", Q: "𝘘", R: "𝘙", S: "𝘚", T: "𝘛", U: "𝘜",
      V: "𝘝", W: "𝘞", X: "𝘟", Y: "𝘠", Z: "𝘡"
    };
    return text.split('').map(char => italicMap[char] || char).join('');
  };

  const calculateTextStatistics = () => {
    const text = textareaValue;

    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");

    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  const handleDownload = () => {
    const element = document.createElement("a");
    const file = new Blob([convertedText], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "italic_text.txt";
    document.body.appendChild(element);
    element.click();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(convertedText);
  };

  const handleClear = () => {
    setTextareaValue("");
    setConvertedText("");
  };

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Italic Text Generator</h2>
          <p>
            Do you want to convert your text into an italic font? Then use this
            simple and free online italic text generator. All you have to do is
            write the words that you want to be converted into italics in the
            left-hand field of the italicized generator, then as you write it
            out, you’re going to see the font get converted into italic text on
            the right. Once you are done, simply copy the italic text and paste
            it where you want.
          </p>
          <div className="textarea-container">
            <textarea
              value={textareaValue}
              onChange={handleChange}
              placeholder="Start typing your notes here..."
              rows="8"
             className="textarea-animated"
            />
            <textarea
              value={convertedText}
              placeholder="Converted text will appear here..."
              rows="8"
            className="textarea-animated"
              readOnly
            />
          </div>
          <div className="stats-text">
            
              Words: {calculateTextStatistics().wordCount} | Letters: {calculateTextStatistics().letterCount} | Sentences: {calculateTextStatistics().sentenceCount} | Lines: {calculateTextStatistics().lineCount}
            
          </div>
          <div  className="btn1-container">
            <button class="btn-421" onClick={handleDownload}>Download Text</button>
            <button class="btn-421" onClick={handleCopy}>Copy to Clipboard</button>
            <button class="btn-421" onClick={handleClear}>Clear</button>
          </div>
        </div>
        <br/>
        <div className="content1">
          <h3>Italics Font Text Converter</h3>
          <p>
            When you want to draw your audience’s attention to something in
            particular, it can be wise to use unique text layouts. For example,
            have you thought about using italic text to try and draw attention
            to your content? That’s a great idea. Italic text tends to be
            something that can help to draw emphasis or create a clear sign of
            importance. When used in the right way, it can be transformative to
            help you add a bit of extra style to your text, whilst also ensuring
            you have something that can really make a big impression.
          </p>
          <p>
            By using our italic text converter, though, you can turn a large
            amount of text around in a matter of seconds. Simply copy in the
            text you wish to edit into the left-hand box, and an italicized
            version will come out on the right-hand box. This saves you valuable
            time, effort, and stress. Instead of having to self-edit using the
            built-in functions of a word processor, this can automatically
            adjust everything as you need it.
          </p>
          <p>
            Time is a valuable commodity and saving yourself as much time as you
            can when it comes to editing is very important indeed. That is why
            we highly recommend you come to take a look at the various options
            we can provide you with via our text converter.
          </p>
          <p>
            An italic text converter can easily adjust the whole layer of text,
            ensuring that it looks fresher and simpler. It can be great for
            providing emphasis, drawing attention to any particular piece of
            text you feel is important, or simply making something stand out a
            bit more for the audience that you have in mind.
          </p>
          <p>
            If you want to keep things moving along quickly and easily, our
            italic text converter offers an ideal opportunity to make your text
            change without any personal adjustment.
          </p>
        </div>
        <br/>
        <div className="content1">
          <h3>How Does the Italic Case Converter Work?</h3>
          <p>
            Simply follow the instructions here. Write out the content (or if
            you already have the content to hand, copy and paste it) into the
            left field. This is where your normal text goes. You will then see
            in the right field, that’s where the text gets transformed into the
            italics version.
          </p>
          <p>
            Once you’ve done this, you can simply head over to the right-hand
            column, select it all and then copy it and you will then be able to
            paste it wherever you desire.
          </p>
          <p>
            If you are looking for an example of italic text then please see
            below:
          </p>
          <p>𝘛𝘩𝘪𝘴 𝘪𝘴 𝘢𝘯 𝘦𝘹𝘢𝘮𝘱𝘭𝘦 𝘰𝘧 𝘪𝘵𝘢𝘭𝘪𝘤 𝘵𝘦𝘹𝘵.</p>
          <p>
            If you have any further suggestions on improving the italic text
            tool further, please also get in touch, as we would love to hear any
            ideas you might have.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ItalicTextGenerator;
